import logger from "../utils/logger";
export const openEditAccount = (account, setEditAccount, setEditForm) => {
  setEditAccount(account);
  setEditForm({
    account_name: account.account_name || '',
    api_key: '',
    client_id: '',
    client_secret: ''
  });
};
export const closeEditAccount = (setEditAccount, setEditForm) => {
  setEditAccount(null);
  setEditForm({
    account_name: '',
    api_key: '',
    client_id: '',
    client_secret: ''
  });
};
export const handleEditSubmit = async ({
  event,
  editAccount,
  editForm,
  request,
  setEditBusy,
  setStatus,
  showStatus,
  loadMarketplaces,
  closeEditAccount,
  companyId,
  returnResult = false
}) => {
  event.preventDefault();
  if (!editAccount) return;
  setEditBusy(true);
  setStatus(null);
  try {
    const payload = {};
    if (editForm.account_name.trim()) {
      payload.account_name = editForm.account_name.trim();
    }
    if (editForm.api_key.trim()) {
      payload.api_key = editForm.api_key.trim();
    }
    if (editAccount.marketplace_type === 'ozon') {
      if (editForm.client_id.trim()) {
        payload.client_id = editForm.client_id.trim();
      }
      if (editForm.client_secret.trim()) {
        payload.client_secret = editForm.client_secret.trim();
      }
    }
    if (!Object.keys(payload).length) {
      showStatus('info', 'Нет изменений для сохранения.');
      setEditBusy(false);
      return returnResult ? {
        updated: false
      } : undefined;
    }
    await request(`/api/v1/marketplaces/${editAccount.id}`, {
      method: 'PATCH',
      body: JSON.stringify(payload)
    });
    showStatus('success', 'Кабинет обновлён.');
    await loadMarketplaces(companyId);
    closeEditAccount();
    return returnResult ? {
      updated: true
    } : undefined;
  } catch (error) {
    logger.error(error);
    showStatus('error', 'Не удалось обновить кабинет.');
    return returnResult ? {
      updated: false
    } : undefined;
  } finally {
    setEditBusy(false);
  }
};
